import { render, staticRenderFns } from "./AiEditFormModal.vue?vue&type=template&id=56d32c6e&scoped=true"
import script from "./AiEditFormModal.vue?vue&type=script&lang=js"
export * from "./AiEditFormModal.vue?vue&type=script&lang=js"
import style0 from "./AiEditFormModal.vue?vue&type=style&index=0&id=56d32c6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d32c6e",
  null
  
)

export default component.exports